module.exports = __webpack_public_path__ + "static/media/piano.67039e87.jpg";